module.exports = __webpack_public_path__ + "static/img/business-woman-2697954_1920.d254f3c3.jpg";